import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

interface Props {
  password: string;
  hash: string | null;
}

const resetPasswordMutation = () => useMutation({
  mutationKey: ['resetPassword'],
  mutationFn: (body: Props) => agent.getClient(false).post('/auth/reset/password', body),
  onSuccess: () => { },
});

export default resetPasswordMutation;
